import { PubsubEventTypeEnum } from "./enums";
export interface PubsubEvent<T> {
  sequenceId: number,
  type: string,
  from: string,
  data: PubsubEventData<T>,
  dataType: string
}
export interface PubsubEventData<T> {
  type: PubsubEventTypeEnum,
  data: T
}